<template>
  <v-app>
    <router-view />

    <!-- Global toast -->
    <v-snackbar
      v-model="$toast.state.show"
      :timeout="$toast.state.timeout"
      :color="$toast.state.color"
      location="bottom"
      elevation="6"
    >
      {{ $toast.state.message }}
      
      <template v-slot:actions>
        <v-btn
          color="white"
          variant="text"
          @click="$toast.state.show = false"
        >
          {{ $t('toast.close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>

export default {
  name: 'App',


  created(){
    this.$vuetify.theme.global.name = this.store.darkTheme ? 'customDark' : 'customLight'
  },

  watch: {
    'store.darkTheme'(newValue) {
      this.$vuetify.theme.global.name = newValue ? 'customDark' : 'customLight'
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@300;400;500;600;700&family=Fraunces:ital,opsz,wght@0,9..144,300;0,9..144,400;0,9..144,500;1,9..144,300;1,9..144,400;1,9..144,500&display=swap');

body {
  font-family: 'Nunito', -apple-system, system-ui, sans-serif;
}

.font-display {
  font-family: 'Fraunces', Georgia, serif;
}

.clickable-area:hover {
  background-color: rgba(var(--v-theme-primary), 0.05);
  cursor: pointer;
}
</style>
